// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__A-9yB","bigScore":"style__bigScore__OXVl9","targetIndicator":"style__targetIndicator__5g45d"};